import styled from 'styled-components';
import { InputText, TextArea } from 'ui/inputs';
import { Button, FauxButton } from 'ui/button';
import { body2, colors, heading3, spacing } from 'ui/theme';
import { EDIT_INPUT_TEST_ID } from './constants';

export const StyledButton = styled(Button)`
  max-width: 80ch;
  padding-left: 0;
  &::before {
    border-width: 0px;
  }
  svg {
    flex-shrink: 0;
  }
  &[data-input-type='pageHeader'] {
    padding: ${spacing.base} ${spacing.threeQuarter} ${spacing.base} 0;
    height: ${spacing.doubleHalf};
  }
  :focus-visible {
    outline: ${spacing.single} solid ${colors.borderInteractive};
    background-color: ${colors.grey5};
  }
  :focus-visible,
  :hover {
    color: ${colors.grey80};
    padding-left: ${spacing.threeQuarter};
    margin-left: ${spacing.single};
    svg path {
      stroke: ${colors.grey80} !important;
    }
  }
`;

export const StyledButtonArea = styled(StyledButton)`
  align-items: flex-start;
  height: auto;
  margin-bottom: ${spacing.quarter};
  padding-top: 7px;
  padding-bottom: 7px;
`;

export const StyledFauxButton = styled(FauxButton)`
  max-width: 80ch;
  padding-left: 0;
  &::before {
    border-width: 0px;
  }
  svg {
    flex-shrink: 0;
  }
  &[data-input-type='pageHeader'] {
    padding: ${spacing.base} ${spacing.threeQuarter} ${spacing.base} 0;
    height: ${spacing.doubleHalf};
  }
`;

export const StyledFauxButtonArea = styled(StyledFauxButton)`
  cursor: default;
  height: auto;
  margin-bottom: ${spacing.quarter};
  padding-top: 7px;
  padding-bottom: 7px;
  :active,
  :hover {
    background-color: unset;
    border-color: transparent;
    box-shadow: none;
    transform: none;
  }
`;

export const StyledInput = styled(InputText)`
  background-color: inherit;
  border: none;
  margin-left: ${spacing.single};
  input {
    padding: 0;
    background-color: inherit;
    width: 40ch;
    :focus {
      border: none;
      background: transparent;
    }
    &[data-input-type='pageHeader'] {
      ${heading3}
    }
  }
`;

export const StyledTextArea = styled(TextArea)`
  background-color: inherit;
  border: none;
  margin-left: ${spacing.single};
  textarea {
    background-color: inherit;
    max-width: calc(100vw - ${spacing.x4});
    width: 80ch;
  }
`;

export const NameDisplay = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &[data-input-type='pageHeader'] {
    ${heading3}
  }
`;

export const NameDisplayArea = styled.span`
  ${body2}
  color: ${colors.textSecondary};
  text-align: left;
`;

export const NameDisplayPlaceholder = styled.span`
  color: ${colors.grey50};
`;

/**
 * this container is a way around accessing the ui/inputText element's wrapper, to style it
 * which is currently impossible due to the way the ui/inputText is built.
 *
 * In this very specific case, we want the height of the pageHeader variant to match the height of buttons,
 * since they are often used together in the same row. Hence this css wrapper.
 */
export const InputContainer = styled.div`
  margin-bottom: ${spacing.quarter};
  &[data-input-type='pageHeader'] {
    [data-test='${EDIT_INPUT_TEST_ID}-wrapper'] {
      padding-top: 0;
      padding-bottom: 0;
      height: ${spacing.doubleHalf};
    }
  }
`;
